import { Capacitor } from "@capacitor/core";

export type NativePlatform = "ios" | "android" | "web";

type CapacitorGlobal = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

type NativeBridgeWindow = Window & typeof globalThis & {
  Capacitor?: CapacitorGlobal;
  webkit?: { messageHandlers?: { bridge?: unknown } };
};

export function nativeBridgeWindow() {
  return window as NativeBridgeWindow;
}

export function isAndroidWebView(userAgent = window.navigator.userAgent) {
  return /Android/i.test(userAgent) && /; wv\)|\bwv\b/i.test(userAgent);
}

export function nativeAppVersionFromUserAgent(userAgent = window.navigator.userAgent) {
  const match = userAgent.match(/\bFlexTechMember\/([0-9][0-9A-Za-z._-]*)(?:\(([0-9A-Za-z._-]+)\))?/);
  if (!match) return null;

  return {
    version: match[1],
    build: match[2] || null
  };
}

export function nativePlatform(): NativePlatform {
  const globalCapacitor = nativeBridgeWindow().Capacitor;
  const platform = Capacitor.getPlatform();
  const globalPlatform = globalCapacitor?.getPlatform?.();
  const userAgent = window.navigator.userAgent;

  if (platform === "ios" || platform === "android") return platform;
  if (globalPlatform === "ios" || globalPlatform === "android") return globalPlatform;
  if (nativeBridgeWindow().webkit?.messageHandlers?.bridge) return "ios";
  if (isAndroidWebView(userAgent)) return "android";
  if (nativeAppVersionFromUserAgent(userAgent)) {
    if (/Android/i.test(userAgent)) return "android";
    if (/iPhone|iPad|iPod/i.test(userAgent)) return "ios";
  }

  return isNativePreviewRuntime() ? "ios" : "web";
}

export function isNativeRuntime() {
  const globalCapacitor = nativeBridgeWindow().Capacitor;
  const platform = Capacitor.getPlatform();
  const globalPlatform = globalCapacitor?.getPlatform?.();

  return Boolean(
    Capacitor.isNativePlatform() ||
    platform === "ios" ||
    platform === "android" ||
    globalCapacitor?.isNativePlatform?.() ||
    globalPlatform === "ios" ||
    globalPlatform === "android" ||
    nativeBridgeWindow().webkit?.messageHandlers?.bridge ||
    isAndroidWebView() ||
    nativeAppVersionFromUserAgent()
  );
}

export function isNativePreviewRuntime() {
  return document.getElementById("member-portal-root")?.dataset.memberAppPreview === "ios";
}

export function isNativeUiRuntime() {
  return isNativeRuntime() || isNativePreviewRuntime();
}
